import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/pickup-cost')({
  component: AdminPickupCostRoute,
});

function AdminPickupCostRoute() {
  return <Outlet />;
}
